import type { GTMEcommerceReturnType, GTMItemData, GTMItemsReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';
import { calculateValue } from '../GTMHelpers';

interface GTMViewItemEcommerceReturnType {
    value: number;
    items: Omit<GTMItemsReturnType, 'index'>[];
    date_selected: boolean;
}

interface GTMViewItemModelData extends GTMItemData {
    isDateSelected: boolean;
}

export default class GTMViewItemModel extends GTMBaseModel {
    public static parseToGTMData({
        isDateSelected,
        id,
        title,
        country,
        region,
        department,
        place,
        discount,
        pricePerNight,
        instantBooking,
        quantity = 1
    }: GTMViewItemModelData): GTMEcommerceReturnType<GTMViewItemEcommerceReturnType> {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'view_item',
            ecommerce: {
                value: calculateValue(pricePerNight, quantity),
                date_selected: isDateSelected,
                items: [
                    {
                        item_id: id,
                        item_name: title,
                        item_category: country,
                        item_category2: region,
                        item_category3: department,
                        item_category4: place,
                        discount,
                        quantity,
                        price: pricePerNight,
                        instant_booking: instantBooking
                    }
                ]
            }
        };
    }
}
